export default __webpack_public_path__ + "static/media/cover_2.085eadf4.jpg";